import { Fragment, useState, forwardRef } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { Toggle, Button } from "../../components";
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../slices/staffSlice';
import { useNavigate } from 'react-router-dom';
import { authStaff } from '../../utils/constants';
import { fetchRequests } from '../../Requests/getRequests';
import { show } from '../../slices/toastSlice';
import { HugeiconsIcon } from '@hugeicons/react';
import { Settings02Icon, ArrowDown01Icon } from '@hugeicons/core-free-icons';

function LoanSettings({ loan }) {

    const acceessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [reschedule, setReschedule] = useState(loan?.reschedule === "active" ? false : true);
    const [allMessages, setAllMessages] = useState(loan?.messaging?.other);
    const [balanceMessages, setBalanceMessages] = useState(loan?.messaging?.balance);
    const [penalMessages, setPenalMessages] = useState(loan?.messaging?.penalRate);
    const [processing, setProcessing] = useState(false);

    const handleRequest = async () => {
        setProcessing(true);
        let res = await fetchRequests(`/loans/staff/loan-settings`, "POST", authStaff(acceessToken), {}, {
            _id: loan?._id,
            reschedule,
            messaging: { other: allMessages, balance: balanceMessages, penalRate: penalMessages }
        });
        setProcessing(false);

        if (res.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: res?.err }));
            return;
        }
        dispatch(show({ type: "success", state: true, message: "Loan settings updated successfully" }));
        setTimeout(() => window.location.reload(), 2000);
    };

    const ToggleSwitch = forwardRef(({ label, value, setValue }, ref) => (
        <Toggle label={label} value={value} setValue={setValue} />
    ));

    const ButtonComponent = forwardRef(({ btnText, btnClasses, btnFunction, processing, btnType }, ref) => (
        <Button btnText={btnText} btnClasses={btnClasses} btnFunction={btnFunction} processing={processing} btnType={btnType} />
    ));

    return (
        <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors shadow-sm">
                <HugeiconsIcon icon={Settings02Icon} size={15} className="text-gray-400" />
                Loan Settings
                <HugeiconsIcon icon={ArrowDown01Icon} size={13} className="text-gray-400" />
            </Menu.Button>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="absolute right-0 mt-1.5 w-72 origin-top-right bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 p-4 z-50 space-y-3">
                    <Menu.Item>
                        <ToggleSwitch label="Reschedule loan" value={reschedule} setValue={setReschedule} />
                    </Menu.Item>
                    <div className="border-t border-gray-100 dark:border-gray-700" />
                    <Menu.Item>
                        <ToggleSwitch
                            label={`All Messages (${loan?.messaging?.other ? 'enabled' : 'disabled'})`}
                            value={allMessages}
                            setValue={setAllMessages}
                        />
                    </Menu.Item>
                    <div className="border-t border-gray-100 dark:border-gray-700" />
                    <Menu.Item>
                        <ToggleSwitch
                            label={`Balance Messages (${loan?.messaging?.balance ? 'enabled' : 'disabled'})`}
                            value={balanceMessages}
                            setValue={setBalanceMessages}
                        />
                    </Menu.Item>
                    <div className="border-t border-gray-100 dark:border-gray-700" />
                    <Menu.Item>
                        <ToggleSwitch
                            label={`Penal Messages (${loan?.messaging?.penalRate ? 'enabled' : 'disabled'})`}
                            value={penalMessages}
                            setValue={setPenalMessages}
                        />
                    </Menu.Item>
                    <div className="border-t border-gray-100 dark:border-gray-700" />
                    <Menu.Item>
                        <ButtonComponent
                            btnText="Save"
                            btnClasses="form-button w-full px-6 mt-1"
                            btnFunction={handleRequest}
                            processing={processing}
                            btnType="button"
                        />
                    </Menu.Item>
                </Menu.Items>
            </Transition>
        </Menu>
    );
}

export default LoanSettings;
